import React, { useState } from "react";
import { Header, Footer, MobileDrawer } from "./components"; // Remove FooterCTA
import AppRoutes from "./routes/AppRoutes";

const App = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState("/");

  const navigate = (path) => {
    setCurrentPage(path);
    setIsDrawerOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header
        onNavigate={navigate}
        currentPath={currentPage}
        onMenuClick={() => setIsDrawerOpen(true)}
      />

      <MobileDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        onNavigate={navigate}
      />

      <main className="pt-16 pb-0 md:pb-0">
        {" "}
        {/* Added pb-20 for mobile spacing */}
        <AppRoutes currentPath={currentPage} />
      </main>

      <Footer onNavigate={navigate} />
      {/* Removed <FooterCTA /> - it's now inside Footer component */}
    </div>
  );
};

export default App;
